import {truncate} from 'webapp-lib/utils';

export const NOT_FOUND = '—';

export const divideAndTruncate = (
  value: string,
  separator: string,
  lengthLimit: number
): string => {
  const dividedArray = value.split(separator);
  const dividedName = dividedArray.map((item) => truncate(item, lengthLimit));

  return dividedName.join(separator);
};

export const capitalizeFirstLetter = (value: string): string =>
  value.charAt(0).toUpperCase() + value.slice(1);

/** Parses a possible null string to a non NaN number with fallback 0 */
export const parseNonNaNFloat = (numb: string | undefined | null): number =>
  parseFloat(numb || '0') || 0;

/** Removes leading/trailing whitespace and grouping separators. */
export const prepareNumericString = (numeric: string): string =>
  numeric
    .trim()
    .replaceAll(/[,]/gu, '.')
    .replaceAll(/[^\-0-9.]/gu, '');

/**
 * Formats numeric strings into numbers. Note that this does not validate the
 * input and it might return NaN.
 */
export const numericStringToNumber = (numeric: string): number =>
  Number(prepareNumericString(numeric));

/** Converts a decimal string like "0.2" to a percentage value like "20 %". */
export const toFraction = (taxRate: string, {decimals = 0} = {}): string => {
  // The locale is currently hard-coded to avoid problems with other locales (for example,
  // comma instead of period as the decimal separator).
  const numberFormat = new Intl.NumberFormat('de-CH', {
    maximumFractionDigits: decimals,
    minimumFractionDigits: decimals,
  });
  const taxRateNumeric = parseFloat(taxRate) * 100;

  return `${numberFormat.format(taxRateNumeric)} %`;
};

/** Converts umlauts to their ASCII-Equivalent. Catches most, but not all cases. */
export const normalizeUmlauts = (str: string): string => {
  const combining = /[\u0300-\u036F]/gu;
  return str.normalize('NFKD').replace(combining, '');
};

/** Returns true if charCode is in [a-zA-Z0-9] */
export const charCodeIsAlphanumeric = (charCode: number): boolean => {
  if (charCode > 47 && charCode < 58) {
    return true;
  } // 0-9
  if (charCode > 64 && charCode < 91) {
    return true;
  } // A-Z
  if (charCode > 96 && charCode < 123) {
    return true;
  } // a-z
  return false;
};

/** Returns the letter of the corresponding section for the string in a list with sections (such as contacts) */
export const charForSection = (str: string): string | undefined => {
  const char = normalizeUmlauts(str.charAt(0));
  if (charCodeIsAlphanumeric(char.charCodeAt(0))) {
    return char.toUpperCase();
  } else {
    return undefined;
  }
};
